<template>
  <div class="season-switcher">
    <label for="seasonSelect">انتخاب فصل :</label>
    <select id="seasonSelect" v-model="selectedSeasonId" @change="onSeasonChange">
      <option v-for="season in seasons" :key="season.id" :value="season.id">
        {{ season.name }}
      </option>
    </select>
  </div>
</template>

<script>
export default {
  name: 'SeasonSwitcher',
  props: {
    competitionId: {type: [Number, String], required: true},
    initialSeasonId: {type: [Number, String], default: null}
  },
  data() {
    return {
      selectedSeasonId: null,
      seasons: []
    }
  },
  async created() {
    const allSeasons = await this.$store.dispatch('fetchSeasons', this.competitionId);
    this.seasons = this.filterSeasons(allSeasons)
    // اگر initialSeasonId داده شده، از آن استفاده کن، وگرنه اولین فصل
    this.selectedSeasonId = this.initialSeasonId || (this.seasons.length > 0 ? this.seasons[0].id : null);
    if (this.selectedSeasonId) {
      this.$emit('season-change', this.selectedSeasonId);
    }
  },
  watch: {
    competitionId() {
      this.$store.dispatch('fetchSeasons', this.competitionId).then(allSeasons => {
        // ✅ فیلتر را اینجا هم اعمال کن
        this.seasons = this.filterSeasons(allSeasons)

        this.selectedSeasonId = this.seasons.length > 0 ? this.seasons[0].id : null;
        if (this.selectedSeasonId) {
          this.$emit('season-change', this.selectedSeasonId);
        }
      });
    }
  },
  methods: {
    onSeasonChange() {
      this.$emit('season-change', this.selectedSeasonId);
    },
    filterSeasons(seasons) {
      // فصل‌های ۲۰۲۲ به بعد — فصل‌های بک‌فیل‌شدهٔ تاریخی (syncLeagueHistory) هم دیده شوند
      return seasons.filter(season => {
        const year = new Date(season.startDate).getFullYear();
        return year >= 2022 && year <= 2027;
      });
    }
  }
}
</script>

<style scoped>
.season-switcher {
  margin-bottom: 20px;
  align-items: center;
  display: flex;
  column-gap: 10px;
}

.season-switcher select {
  padding: 8px 12px;
  border-radius: 6px;
  border: 1px solid #ddd;
  font-size: 14px;
  background: white;
  min-width: 150px;
}
</style>